// Chargebee
export const CHARGEBEE_SCRIPT_URL = 'https://js.chargebee.com/v2/chargebee.js'

// URLs
export const CONTACT_US_URL = 'https://www.flagsmith.com/contact-us'
export const ON_PREMISE_HOSTING_URL =
  'https://www.flagsmith.com/on-premises-and-private-cloud-hosting'

// Support
export const SUPPORT_EMAIL = 'support@flagsmith.com'
export const SUPPORT_EMAIL_URL = 'mailto:support@flagsmith.com'
